/*
 * Copyright © 2015-2020 Serenova, LLC. All rights reserved.
 */

import ContactLayoutsDetailsPanel from './layout';

export default ContactLayoutsDetailsPanel;
